// eslint-disable-next-line no-restricted-imports -- (CSS imports are ok)
import "@khanacademy/mathjax-renderer/src/css/mathjax.css";
// eslint-disable-next-line no-restricted-imports -- (CSS imports are ok)
import "@khanacademy/mathjax-renderer/src/css/safari-hacks.css";
// eslint-disable-next-line no-restricted-imports -- (CSS imports are ok)
import "@khanacademy/mathjax-renderer/src/css/selectable.css";

import {
    MathJaxRenderer,
    type RenderResult,
} from "@khanacademy/mathjax-renderer";
import {RequestInfo} from "@khan/shared-core";
import {staticUrl} from "@khan/urls";

// Anyone who wants to render math with MathJax should import the functions
// from this file. DON'T import from @khanacademy/mathjax-renderer directly.
//
// The purpose of this file is to instantiate a singleton MathJaxRenderer with
// injected dependencies. We have to use a singleton because the MathJax
// library has global state :(

const renderer = new MathJaxRenderer({
    shouldFixUnicodeLayout: true,
    fontURL: windowGlobalExists()
        ? staticUrl("/fonts/mathjax")
        : "/fonts/mathjax",
    locale: RequestInfo.kaLocale,
});

// render() is the primary way we render math content with MathJax.
export const render: (tex: string) => RenderResult = renderer.render;

// Since MathJax isn't adding the math elements to the dom itself (we are,
// via React), it doesn't know when to update its stylesheet. We can call
// updateStyles() after rendering new math content to make sure that all
// the elements will display correctly.
export const updateStyles = renderer.updateStyles;

export const getStyleSheet: () => HTMLStyleElement = renderer.getStyleSheet;

export const hasRenderedAnything: () => boolean = renderer.hasRenderedAnything;

export const resetGlobalState: () => void = renderer.resetGlobalState;

// renderDomElementsFromTexOrThrow throws any error emitted during MathJax
// rendering, even if part of the math could be rendered.
export function renderDomElementsFromTexOrThrow(tex: string): HTMLElement {
    const {domElement, error} = render(tex);
    if (error != null) {
        throw error;
    }
    return domElement;
}

function windowGlobalExists() {
    return typeof window !== "undefined";
}
